import React, { useEffect, useState, useRef } from 'react'
import WidgetHeader from '../../../../components/Widget/Header';
import { Checkbox, Button } from '@arnsbogroup/react-voicearchive'
import NiceModal from '@ebay/nice-modal-react'
import { Timestamp } from 'components/datatable'

const TaskListWidget = ({widget}) => {
  const mounted = useRef(false);
  
  const [tasks, setTasks] = useState([]);
  const [bulkActions, setBulkActions] = useState(null);
  const [checkedTasks, setCheckedTasks] = useState([]);
  const [title, setTitle] = useState('');

  useEffect(() => {
    mounted.current = true;
    fetch(`supplierdashboard/${widget.widgetId}`)
    .then((response) => response.json())
    .then((data) => {
      if (mounted.current) {
        setTasks(data.data.tasks)
        setBulkActions(data.data.bulkActions);
      }
    });

    setTitle(widget.widgetId.replace(/_/g, ' '));

    return () => {
      mounted.current = false;
    };
  }, [])

  const toggleAllTasks = () => {
    if (checkedTasks.length === tasks.length) {
      setCheckedTasks([])
    } else {
      setCheckedTasks(tasks.map((task) => {
        return task.uid
      }))
    }
  };

  const checkTask = (uid) => {
    if (checkedTasks.includes(uid)) {
      setCheckedTasks(checkedTasks.filter((taskUid) => taskUid !== uid));
    } else {
      setCheckedTasks([...checkedTasks, uid]);
    }
  };

  const taskDetails = (uid) => {
    reactHistory.push(`/task/${uid}`)
  };
  
  const bulkApproveTasks = () => {
    if (!checkedTasks.length) {
      toastr.error('Please select tasks')
      return
    }
    var data = new FormData();
    data.append('taskIds[]', checkedTasks);

    fetch('/supplierviewdisplay/bulkApproveTasks.json', {
      method: 'POST',
      body: data
    })
    .then((response) => response.json())
    .then((response) => {
      if (response.success) {
        reactHistory.push('/reload-dashboard')
      }
    })
  }
  
  const bulkRejectTasks = () => {
    if (!checkedTasks.length) {
      toastr.error('Please select tasks')
      return
    }
    var data = new FormData();
    data.append('taskIds[]', checkedTasks);

    fetch('/supplierviewdisplay/bulkDenyTasks.json', {
      method: 'POST',
      body: data
    })
    .then((response) => response.json())
    .then((response) => {
      if (response.success) {
        reactHistory.push('/reload-dashboard')
      }
    })
  }
  
  const widget_id = `ID_${widget.widgetId}`;
  return (
    <li className="bg-white border m-4 shadow rounded border-gray-400" key={widget_id} id={widget_id}>
      <WidgetHeader widget={widget} widgetTitle={title} />

      <div className="w-full text-xs">
        {bulkActions &&
          <div className="flex justify-between items-center p-2 border-b">
            <div className="w-4">
              <Checkbox
                checked={checkedTasks.length === tasks.length}
                onChange={() => {
                  toggleAllTasks()
                }}
              />
            </div>
            <div className="flex space-x-2">
              {bulkActions.map(({action, label}) => (
                <Button
                  size="sm"
                  onClick={() => eval(`${action}()`)}
                >
                  Bulk {label}
                </Button>
              ))}
            </div>
          </div>
        }
        {tasks.map((task) => (
          <div
            key={task.uid}
            className={`hover:bg-gray-200 flex justify-between border-b ${task['highlight'] ?? false ? 'bg-yellow-100' : ''}`}
            onClick={() => taskDetails(task.uid)}
            title={task['comments']}
          >
            {bulkActions &&
              <div className="p-2 sm:w-10">
                <Checkbox
                  onClick={(e) => e.stopPropagation()}
                  checked={checkedTasks.some((taskId) => taskId == task.uid)}
                  onChange={() => {checkTask(task.uid)}}
                />
              </div>
            }
            <div
              title={task.title}
              className="w-52 p-2 cursor-pointer hover:text-primary truncate sm:w-full"
            >
              {task.title}
            </div>
            <div
              title={task?.type_object?.name}
              className="w-20 p-2 cursor-pointer hover:text-primary truncate sm:w-1/3"
            >
              {task?.type_object?.short_name}
            </div>
            <div className="w-72 p-2 flex justify-between items-center space-x-1">
              <span className="w-1 inline-block ml-2 mr-1">
                {task['comments'] ? <i className="text-yellow-500 fa fa-info"></i> : ''}
              </span>
              <Timestamp includeStatus>{task.deadline}</Timestamp>
            </div>
          </div>
        ))}
      </div>
    </li>
  );

}

export default TaskListWidget;
